module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-20.fa1975b7.png";